<script setup>
import { ref, onMounted } from 'vue'
//Components
import HeaderTemplate from 'Common/components/templates/HeaderTemplate.vue'
import AppHeaderActions from 'Modules/AppHeaderActions.vue'
import AppFitlers from './AppFilters.vue'
//Util
import { setCookie, getCookie } from 'Common/utils/cookie'
//FeatureFlags
import { showFilters } from '@/featureFlags'

const FILTERS_VISIBLE_COOKIE_KEY = 'isFiltersVisible'
const isFiltersVisible = ref(false)

const toggleIsFiltersVisible = () => {
  isFiltersVisible.value = !isFiltersVisible.value
  setCookie(FILTERS_VISIBLE_COOKIE_KEY, isFiltersVisible.value, 90, '/')
}

onMounted(() => {
  const isFiltersVisibleCookieValue = getCookie(FILTERS_VISIBLE_COOKIE_KEY)
  if (isFiltersVisibleCookieValue !== null) {
    isFiltersVisible.value = isFiltersVisibleCookieValue
  }
})
</script>

<template>
  <div class="flex flex-col h-full w-full">
    <div class="h-12">
      <HeaderTemplate logo-url="/nea_logo.png">
        <template #header-actions>
          <AppHeaderActions
            :is-filters-visible="isFiltersVisible"
            :toggle-is-filters-visible="toggleIsFiltersVisible"
          />
        </template>
      </HeaderTemplate>
    </div>
    <div v-if="isFiltersVisible === true && showFilters === true" class="h-12">
      <AppFitlers />
    </div>
  </div>
</template>
